

exports.__esModule = true;
exports.$Continue3DSRedirectRoute = void 0;
var _squid = require("squid");
require("./directive");
var $Continue3DSRedirectRoute = exports.$Continue3DSRedirectRoute = _squid.$ComponentRoute.extend('$Continue3DSRedirectRoute', {
  path: 'continue3DSRedirect',
  directive: 'xo-continue-threeds-redirect',
  trackingData: {},
  children: []
});
angular.value("$Continue3DSRedirectRoute", $Continue3DSRedirectRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-guest-components/src/continue-3ds-redirect/route.js
// module id = ../node_modules/xo-guest-components/src/continue-3ds-redirect/route.js
// module chunks = 0